module.exports = __webpack_public_path__ + "img/using_help.271a2b84.svg";